import React from "react";
import RoleRoute from "./RoleRoute";

const StaffProtectedRoute = ({ isStaff, ...rest }) => (
    <RoleRoute roles={["doctor"]} {...rest} />
);

export default StaffProtectedRoute;
